import {RetentionApiChartType, RetentionChartType, RetentionType} from 'common/report/retention/util/types';
import {ChartType as CommonChartType} from 'common/report/constants';

export const REPORT_TYPES = {
  ADDICTION: `addiction`,
  RETENTION: `retention`,
};

export const AGGREGATED_ROW_NAME = (reportType: RetentionType) =>
  `Average ${reportType === `addiction` ? `Frequency` : `Retention`}`;

// Map to/from bookmark format
// TODO: consider doing a pass changing API's to be consistent with our unique ChartType enums
export const COMMON_CHART_TYPE_TO_API_CHART_TYPE: {[key in RetentionChartType]: RetentionApiChartType} = {
  // Cast any old line chart bookmarks to table
  [CommonChartType.RetentionLine]: RetentionApiChartType.Table,
  [CommonChartType.RetentionTable]: RetentionApiChartType.Table,
  [CommonChartType.RetentionTrend]: RetentionApiChartType.RetentionTrend,
  [CommonChartType.RetentionTrendMetric]: RetentionApiChartType.RetentionTrendMetric,
};

export const API_CHART_TYPE_TO_COMMON_CHART_TYPE: {[key in RetentionApiChartType]: RetentionChartType} = {
  line: CommonChartType.RetentionLine,
  table: CommonChartType.RetentionTable,
  'retention-trend': CommonChartType.RetentionTrend,
  'retention-trend-metric': CommonChartType.RetentionTrendMetric,
};

export enum RetentionTrackingEvents {
  AddCustomRetentionBucket = `Add custom retention bucket`,
  ClickedAdvancedQuerySettings = `Clicked advanced query settings`,
  ClickedRetentionCriteria = `Clicked retention criteria`,
  ChangeChartType = `Changed chart type`,
  ChangePercentageView = `Changed percentage view`,
  ChangeCumulative = `Changed cumulative`,
  ChangeUnbounded = `Changed unbounded`,
  ChartLegendClick = `Clicked chart legend`,
  ScrolledTable = `Scrolled table`,
  SortedTable = `Sorted table`,
  PopoverSaveCohort = `[Viewed popover] Save cohort`,
  PopoverClickCreateCohort = `[Viewed popover] Create cohort button`,
  PopoverCancelCreateCohort = `[Viewed popover] Cancel cohort`,
  PopoverViewUsers = `[Viewed popover] View Users`,
  PopoverOpen = `[Viewed popover] Click on a chart/cell`,
}

export enum RetentionTrackingProperties {
  Cumulative = `cumulative`,
  NonCumulative = `non-cumulative`,
  Unbounded = `unbounded`,
  Bounded = `N day`,
}
